import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "registroGeralPipe" })
export class RegistroGeralPipe implements PipeTransform {
  transform(value: string): any {
    if (!value) return "";
    return value.replace(/(\d{2})(\d{3})(\d{3})(\d{1})/g, "$1.$2.$3-$4");
  }
}
